export const tableEstimateHead = [
  { name: 'Номер', id: 'number' },
  { name: 'Тип', id: 'type' },
  { name: 'Наименование', id: 'name' },
  { name: 'Тип, марка', id: 'typeMark' },
  { name: 'Артикул', id: 'vendorCode' },
  { name: 'Ед.изм.', id: 'storageUnit' },
  { name: 'Количество', align: 'right', id: 'count' },
  { name: 'Цена', align: 'right', id: 'price' },
  { name: 'Сумма', align: 'right', id: 'summ' },
]